import { put, takeLatest } from 'redux-saga/effects';
import { SetCodiceModuli } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';

// utils
import format from 'date-fns/format';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, IDModulo, dataDecorr, codiceUtente, tipologia, sn, moduli } }) {
    try {

        const token = yield authService.getAccessToken();
               
        // Creo l'header per l'HttpPost. NB: PRIMA inizializzare headers, POI aggiungere il body contenente il json
        var myHeaders = new Headers();

        if (token) myHeaders.append('Authorization', `Bearer ${token}`);
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');

        var requestObj = {
            method: 'POST',
            headers: myHeaders,
        };

        requestObj.body = JSON.stringify(JSON.stringify(moduli));

        const response = yield fetch('/Licenses/SetCodiceModuli/'
            + pk + '/'
            + IDModulo + '/'
            + format(dataDecorr, 'yyyy-MM-dd') + '/'        //formatto in 'yyyy-MM-dd' per semplificare chiamata controller
            + codiceUtente + '/'
            + tipologia + '/'
            + sn, requestObj);


        let isInserted = '';

        isInserted = yield response.json();

        if (isInserted === "inserted")
            yield put(SetCodiceModuli.creators.setCodiceModuliSuccess({ isInserted }));
        else yield put(SetCodiceModuli.creators.setCodiceModuliFailed(isInserted));

    } catch (e) {
        yield put(SetCodiceModuli.creators.setCodiceModuliFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(SetCodiceModuli.types.SET_CODICE_MODULI_REQUEST, runAction);
}